// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.draggableTaskRow_input__container__hmyYo {
  display: flex;
  flex-direction: column;
  width: max-content;
}

.draggableTaskRow_input__container__hmyYo:focus-within {
  outline: 1px dashed #c2c2c2;
  outline-offset: -1px;
}

.draggableTaskRow_input__task__C627X,
.draggableTaskRow_input__description__VBT1Q {
  border: none;
  outline: none;
  padding: 2px;
  background-color: transparent;
  width: 6.5rem;
  box-sizing: border-box;
}

.draggableTaskRow_input__task__C627X {
  text-transform: uppercase;
  font-weight: bold;
}

.draggableTaskRow_input__description__VBT1Q {
  font-size: 0.75rem;
  color: grey;
}

.draggableTaskRow_input__task__C627X:focus,
.draggableTaskRow_input__description__VBT1Q:focus {
  outline: 1px dashed #c2c2c2;
  outline-offset: -1px;
}

.draggableTaskRow_input__row__f-2jq {
  width: 2rem;
  /* outline: 1px solid #c2c2c2; */
  font-weight: bold;
  border: none;
  outline: none;
  outline-offset: -1px;
  text-align: right;
  background-color: transparent;
}

.draggableTaskRow_input__row__f-2jq:focus-within {
  outline: 1px dashed #c2c2c2;
  outline-offset: -1px;
}

.draggableTaskRow_input__row_text__WR5Yk {
  font-size: 0.7rem;
}

.draggableTaskRow_input__row_comment__PWW\\+l {
  width: 10rem;
  outline: 1px solid #c2c2c2;
  outline-offset: -1px;
}

.draggableTaskRow_pd_0__wtllx {
  padding: 0;
}

.draggableTaskRow_pd_tp__05__kU\\+mC {
  padding-top: 0.5rem;
}

.draggableTaskRow_add_button__\\+ItEz {
  color: #000;
  background-color: burlywood;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* For Mozilla Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}

.draggableTaskRow_input-wrapper__2kRn3 {
  position: relative;
  display: flex;
  align-items: center;
}

.draggableTaskRow_input-wrapper__2kRn3 button {
  position: absolute;
  right: 0; /* Adjust as needed */
  /* Additional styles for the button */
}
`, "",{"version":3,"sources":["webpack://./src/components/DraggableTasks/css/draggableTaskRow.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;;EAEE,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;;EAEE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,gCAAgC;EAChC,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,oBAAoB;EACpB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;EACxB,SAAS;AACX;;AAEA,wBAAwB;AACxB;EACE,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ,EAAE,qBAAqB;EAC/B,qCAAqC;AACvC","sourcesContent":[".input__container {\n  display: flex;\n  flex-direction: column;\n  width: max-content;\n}\n\n.input__container:focus-within {\n  outline: 1px dashed #c2c2c2;\n  outline-offset: -1px;\n}\n\n.input__task,\n.input__description {\n  border: none;\n  outline: none;\n  padding: 2px;\n  background-color: transparent;\n  width: 6.5rem;\n  box-sizing: border-box;\n}\n\n.input__task {\n  text-transform: uppercase;\n  font-weight: bold;\n}\n\n.input__description {\n  font-size: 0.75rem;\n  color: grey;\n}\n\n.input__task:focus,\n.input__description:focus {\n  outline: 1px dashed #c2c2c2;\n  outline-offset: -1px;\n}\n\n.input__row {\n  width: 2rem;\n  /* outline: 1px solid #c2c2c2; */\n  font-weight: bold;\n  border: none;\n  outline: none;\n  outline-offset: -1px;\n  text-align: right;\n  background-color: transparent;\n}\n\n.input__row:focus-within {\n  outline: 1px dashed #c2c2c2;\n  outline-offset: -1px;\n}\n\n.input__row_text {\n  font-size: 0.7rem;\n}\n\n.input__row_comment {\n  width: 10rem;\n  outline: 1px solid #c2c2c2;\n  outline-offset: -1px;\n}\n\n.pd_0 {\n  padding: 0;\n}\n\n.pd_tp__05 {\n  padding-top: 0.5rem;\n}\n\n.add_button {\n  color: #000;\n  background-color: burlywood;\n}\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n  -webkit-appearance: none;\n  margin: 0;\n}\n\n/* For Mozilla Firefox */\ninput[type=\"number\"] {\n  -moz-appearance: textfield;\n}\n\n.input-wrapper {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.input-wrapper button {\n  position: absolute;\n  right: 0; /* Adjust as needed */\n  /* Additional styles for the button */\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"input__container": `draggableTaskRow_input__container__hmyYo`,
	"input__task": `draggableTaskRow_input__task__C627X`,
	"input__description": `draggableTaskRow_input__description__VBT1Q`,
	"input__row": `draggableTaskRow_input__row__f-2jq`,
	"input__row_text": `draggableTaskRow_input__row_text__WR5Yk`,
	"input__row_comment": `draggableTaskRow_input__row_comment__PWW+l`,
	"pd_0": `draggableTaskRow_pd_0__wtllx`,
	"pd_tp__05": `draggableTaskRow_pd_tp__05__kU+mC`,
	"add_button": `draggableTaskRow_add_button__+ItEz`,
	"input-wrapper": `draggableTaskRow_input-wrapper__2kRn3`
};
export default ___CSS_LOADER_EXPORT___;
